
import { Component, Prop, PropSync, Vue } from 'nuxt-property-decorator'
import OfferTypeSwitcher from '~/components/filters/OfferTypeSwitcher.vue'
import { OfferTypeKey, Provider } from '~/core/offer.types'
import ProviderCommonCard from '~/components/providers/ProviderCommonCard.vue'
import FeaturesBanner, { FeaturesBannerItem } from '~/components/sections/FeaturesBanner.vue'
import ComparatorFeatures from '~/components/comparator/ComparatorFeatures.vue'

@Component({
  components: {
    ComparatorFeatures,
    OfferTypeSwitcher,
    ProviderCommonCard,
    FeaturesBanner,
  },
})
export default class ProviderLayout extends Vue {
  @PropSync('offerType', { required: true, default: '', type: String })
  private selectedOfferType!: OfferTypeKey

  @Prop({ required: true, default: '', type: String })
  readonly pageTitle!: string

  @Prop({ required: true, default: () => ({}), type: Object })
  readonly provider!: Provider

  get featuresTitle () {
    return this.$t('compare.mobile.title') as string
  }

  get featuresSubtitle () {
    return this.$t('compare.mobile.subtitle') as string
  }

  private featureBannersStyles = {
    '--features-icon-size': '32px',
    '--features-padding-y': '1.5rem',
  }

  get featuresBannerTitle (): string {
    switch (this.selectedOfferType) {
      case 'MOBILE_ABO_OFFER':
        return this.$t('compare.mobile.title') as string
      case 'HOME_OFFER':
        return this.$t('compare.home.title') as string
      case 'BUNDLE_OFFER':
        return this.$t('compare.bundle.title') as string
    }
  }

  get featuresBannerItems (): FeaturesBannerItem[] {
    return [
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-time.svg'),
        title: this.$t('compare.banner.other.1.title') as string,
        description: this.$t('compare.banner.other.1.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-crown.svg'),
        title: this.$t('compare.banner.other.2.title') as string,
        description: this.$t('compare.banner.other.2.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-lock.svg'),
        title: this.$t('compare.banner.other.3.title') as string,
        description: this.$t('compare.banner.other.3.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-headphones.svg'),
        title: this.$t('compare.banner.other.4.title') as string,
        description: this.$t('compare.banner.other.4.description') as string,
      },
    ]
  }

  onOfferTypeChange (offerType: OfferTypeKey) {
    this.selectedOfferType = offerType
  }
}
